import { styled } from '@mui/system';
import { Box, TableCell, tableCellClasses } from '@mui/material';

import AgButton from '../../stories/Components/AgButton';
import { AgColor } from '../../stories/Styles/AgColor';

export const Main = styled('main')<{noPadding?: boolean}>`
  height: calc(100% - 20px);
  padding: ${props => props.noPadding ? 0 : '24px 16px' };
`;

export const SmallButton = styled(AgButton)`
  margin-top: 8px;
  height: 24px !important;
  font-size: 10px !important;
  border-color: ${AgColor.primaryMain};
  white-space: nowrap;
`;

export const StyledTableCell = styled(TableCell)(({ isAction }: {isAction?: boolean}) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: '8px 10px',
    backgroundColor: 'white',
    boxShadow: 'none',
    borderRight: `1px solid ${AgColor.grey4}`,
    fontSize: 10,
    fontWeight: 700,
    color: AgColor.grey8,
    verticalAlign: 'middle',
  },
  [`&.${tableCellClasses.body}`]: {
    padding: isAction ? 0 : '18px 10px',
    borderRight: `1px solid ${AgColor.grey4}`,
    fontSize: 12,
    color: AgColor.grey9,
    textAlign: 'center',
    verticalAlign: 'middle',
    fontFamily: 'Inter, Sans-Serif',
  },
}));

/**
 * Modifies the svg height, width, and color
 * @param iconWidth number - icon width
 * @param iconHeight number - icon height
 * @param color string - icon color
 */
export const SVGContainer = styled(Box)(({ iconWidth, iconHeight, color }: { 
  iconWidth: number; 
  iconHeight: number; 
  color: string }) => ({
  svg: {
    width: iconWidth,
    height: iconHeight,
  },
  path: {
    fill: color
  }
}));

export const TableContainer = styled('section')`
  overflow-y: auto;
  max-height: calc(100vh - 730px);
  border: 1px solid ${AgColor.grey4};

  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #e4e2e4;
    border-radius: 6px;
  }
`;